module.exports = "/assets/b64db06be96992139d55779024bc3819.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/OA.png
// module id = 2797
// module chunks = 0